import { NgModule } from '@angular/core';
import { OpenprojectCommonModule } from '../common/openproject-common.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { EarlyWarningsComponent } from './EarlyWarnings.component';

export const EARLY_WARNINGS_ROUTES: Ng2StateDeclaration[] = [
  {
    name: 'early_warnings',
    url: '/early_warnings',
    parent: 'root',
    data: {
      menuItem: 'menu-item-early_warnings'
    },
    component: EarlyWarningsComponent
  }
];

@NgModule({
  imports: [
    OpenprojectCommonModule,
    HttpClientModule,
    FormsModule,
    UIRouterModule.forChild({
      states: EARLY_WARNINGS_ROUTES
    })
  ],
  declarations: [
    EarlyWarningsComponent
  ]
})
export class EarlyWarningsModule { }
